import { Plot, PlotMember, PlotRef, PlotTab } from '../types';
import { shortId } from './format';

/** Section titles for the plot sizes in config.json `plotSnapshotsApi.hosts`; a size that isn't listed shows its key. */
const SIZE_LABELS: Record<string, string> = {
  comp: 'Competition',
};

export const sizeLabel = (size: string): string => SIZE_LABELS[size] || (/^\d+$/.test(size) ? `${size} × ${size}` : size);

/** Overall footprint of a plot in blocks, [x width, z length]; null when the plot server sent no regions. */
export const plotFootprint = (p: Plot): [number, number] | null => {
  const regions = p.regions || [];
  if (regions.length === 0) return null;
  let minX = Infinity;
  let maxX = -Infinity;
  let minZ = Infinity;
  let maxZ = -Infinity;
  regions.forEach((r) => {
    minX = Math.min(minX, r.min[0]);
    maxX = Math.max(maxX, r.max[0]);
    minZ = Math.min(minZ, r.min[2]);
    maxZ = Math.max(maxZ, r.max[2]);
  });
  return [maxX - minX + 1, maxZ - minZ + 1];
};

/** A plot merged with its neighbours spans more than one region. */
export const isMergedPlot = (p: Plot): boolean => (p.regions?.length || 0) > 1;

/** The plot server reports "/plot trust *" (everyone) with the name "*". */
export const EVERYONE = '*';
export const isEveryone = (m: PlotMember): boolean => m.name === EVERYONE;
export const memberName = (m: PlotMember): string => (isEveryone(m) ? 'Everyone' : m.name || shortId(m.uuid));

export const plotRefOf = (size: string, p: Plot): PlotRef => ({ size, world: p.world, plot: p.plot });

export const plotUrl = (ref: PlotRef, tab: PlotTab = 'members'): string =>
  `/plots/${encodeURIComponent(ref.size)}/${encodeURIComponent(ref.world)}/${encodeURIComponent(ref.plot)}/${tab}`;
